/* tslint:disable */
/* eslint-disable */
/**
 * TERES room booking
 * TERES Room booking rest api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BlacklistEntry
 */
export interface BlacklistEntry {
    /**
     * 
     * @type {string}
     * @memberof BlacklistEntry
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof BlacklistEntry
     */
    expiredAt: string;
    /**
     * 
     * @type {string}
     * @memberof BlacklistEntry
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface BookableTimeSlot
 */
export interface BookableTimeSlot {
    /**
     * 
     * @type {string}
     * @memberof BookableTimeSlot
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof BookableTimeSlot
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof BookableTimeSlot
     */
    roomId: string;
    /**
     * 
     * @type {string}
     * @memberof BookableTimeSlot
     */
    roomName?: string;
    /**
     * 
     * @type {string}
     * @memberof BookableTimeSlot
     */
    reference: string;
    /**
     * 
     * @type {number}
     * @memberof BookableTimeSlot
     */
    capacity?: number;
    /**
     * 
     * @type {number}
     * @memberof BookableTimeSlot
     */
    ticketCount?: number;
    /**
     * 
     * @type {string}
     * @memberof BookableTimeSlot
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof BookableTimeSlot
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof BookableTimeSlot
     */
    endTime: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof BookableTimeSlot
     */
    failedRules?: Set<string>;
}
/**
 * 
 * @export
 * @interface BookingResult
 */
export interface BookingResult {
    /**
     * 
     * @type {string}
     * @memberof BookingResult
     */
    bookingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingResult
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingResult
     */
    transactionId?: string;
    /**
     * 
     * @type {Array<Ticket>}
     * @memberof BookingResult
     */
    tickets?: Array<Ticket>;
}
/**
 * 
 * @export
 * @interface CreateHoliday
 */
export interface CreateHoliday {
    /**
     * 
     * @type {string}
     * @memberof CreateHoliday
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHoliday
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateHoliday
     */
    date?: string;
}
/**
 * 
 * @export
 * @interface CreateRoom
 */
export interface CreateRoom {
    /**
     * 
     * @type {string}
     * @memberof CreateRoom
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoom
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRoom
     */
    capacity?: number;
    /**
     * 
     * @type {DayPeriod}
     * @memberof CreateRoom
     */
    openStart?: DayPeriod;
    /**
     * 
     * @type {DayPeriod}
     * @memberof CreateRoom
     */
    openEnd?: DayPeriod;
}
/**
 * 
 * @export
 * @interface CreateTicketDTO
 */
export interface CreateTicketDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketDTO
     */
    timeSlotId: string;
}
/**
 * 
 * @export
 * @interface CreateTimeSlotDefinition
 */
export interface CreateTimeSlotDefinition {
    /**
     * 
     * @type {number}
     * @memberof CreateTimeSlotDefinition
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeSlotDefinition
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeSlotDefinition
     */
    repeatUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeSlotDefinition
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeSlotDefinition
     */
    endTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTimeSlotDefinition
     */
    allDay?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTimeSlotDefinition
     */
    includeHolidays?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTimeSlotDefinition
     */
    daysOfWeek?: Array<CreateTimeSlotDefinitionDaysOfWeekEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateTimeSlotDefinitionDaysOfWeekEnum {
    Monday = 'MONDAY',
    Tuesday = 'TUESDAY',
    Wednesday = 'WEDNESDAY',
    Thursday = 'THURSDAY',
    Friday = 'FRIDAY',
    Saturday = 'SATURDAY',
    Sunday = 'SUNDAY'
}

/**
 * 
 * @export
 * @interface DayPeriod
 */
export interface DayPeriod {
    /**
     * 
     * @type {string}
     * @memberof DayPeriod
     */
    type?: DayPeriodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DayPeriod
     */
    value?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum DayPeriodTypeEnum {
    Day = 'DAY',
    WorkingDay = 'WORKING_DAY'
}

/**
 * 
 * @export
 * @interface Holiday
 */
export interface Holiday {
    /**
     * 
     * @type {string}
     * @memberof Holiday
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Holiday
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof Holiday
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Holiday
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Holiday
     */
    date?: string;
}
/**
 * 
 * @export
 * @interface ICalImportResult
 */
export interface ICalImportResult {
    /**
     * 
     * @type {string}
     * @memberof ICalImportResult
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof ICalImportResult
     */
    end?: string;
    /**
     * 
     * @type {number}
     * @memberof ICalImportResult
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ICalImportResult
     */
    importCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ICalImportResult
     */
    exitingCount?: number;
}
/**
 * 
 * @export
 * @interface RestError
 */
export interface RestError {
    /**
     * 
     * @type {number}
     * @memberof RestError
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    error?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RestError
     */
    details?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    uuid?: string;
    /**
     * 
     * @type {object}
     * @memberof RestError
     */
    payload?: object;
    /**
     * 
     * @type {string}
     * @memberof RestError
     */
    stacktrace?: string;
}
/**
 * 
 * @export
 * @interface ResultBlacklistEntry
 */
export interface ResultBlacklistEntry {
    /**
     * 
     * @type {Array<BlacklistEntry>}
     * @memberof ResultBlacklistEntry
     */
    content?: Array<BlacklistEntry>;
    /**
     * 
     * @type {number}
     * @memberof ResultBlacklistEntry
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface ResultHoliday
 */
export interface ResultHoliday {
    /**
     * 
     * @type {Array<Holiday>}
     * @memberof ResultHoliday
     */
    content?: Array<Holiday>;
    /**
     * 
     * @type {number}
     * @memberof ResultHoliday
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface ResultRoomDTO
 */
export interface ResultRoomDTO {
    /**
     * 
     * @type {Array<RoomDTO>}
     * @memberof ResultRoomDTO
     */
    content?: Array<RoomDTO>;
    /**
     * 
     * @type {number}
     * @memberof ResultRoomDTO
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface ResultTicket
 */
export interface ResultTicket {
    /**
     * 
     * @type {Array<Ticket>}
     * @memberof ResultTicket
     */
    content?: Array<Ticket>;
    /**
     * 
     * @type {number}
     * @memberof ResultTicket
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface ResultTimeSlot
 */
export interface ResultTimeSlot {
    /**
     * 
     * @type {Array<TimeSlot>}
     * @memberof ResultTimeSlot
     */
    content?: Array<TimeSlot>;
    /**
     * 
     * @type {number}
     * @memberof ResultTimeSlot
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface Room
 */
export interface Room {
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Room
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Room
     */
    capacity?: number;
    /**
     * 
     * @type {DayPeriod}
     * @memberof Room
     */
    openStart: DayPeriod;
    /**
     * 
     * @type {DayPeriod}
     * @memberof Room
     */
    openEnd: DayPeriod;
    /**
     * 
     * @type {string}
     * @memberof Room
     */
    imageAlt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Room
     */
    imageExists?: boolean;
}
/**
 * 
 * @export
 * @interface RoomDTO
 */
export interface RoomDTO {
    /**
     * 
     * @type {string}
     * @memberof RoomDTO
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof RoomDTO
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof RoomDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RoomDTO
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof RoomDTO
     */
    capacity?: number;
    /**
     * 
     * @type {DayPeriod}
     * @memberof RoomDTO
     */
    openStart: DayPeriod;
    /**
     * 
     * @type {DayPeriod}
     * @memberof RoomDTO
     */
    openEnd: DayPeriod;
    /**
     * 
     * @type {string}
     * @memberof RoomDTO
     */
    imageAlt?: string;
    /**
     * 
     * @type {string}
     * @memberof RoomDTO
     */
    imageUrl?: string;
}
/**
 * 
 * @export
 * @interface Ticket
 */
export interface Ticket {
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Ticket
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    timeSlotId?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    roomId?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    roomName?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    roomDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    endTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    status?: TicketStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    salutation?: TicketSalutationEnum;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    organisation?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Ticket
     */
    accessibility?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    language?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Ticket
     */
    cancelable?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum TicketStatusEnum {
    New = 'NEW',
    Booked = 'BOOKED',
    Cancelled = 'CANCELLED'
}
/**
    * @export
    * @enum {string}
    */
export enum TicketSalutationEnum {
    None = 'NONE',
    Mr = 'MR',
    Ms = 'MS'
}

/**
 * 
 * @export
 * @interface TicketOwner
 */
export interface TicketOwner {
    /**
     * 
     * @type {string}
     * @memberof TicketOwner
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOwner
     */
    salutation: TicketOwnerSalutationEnum;
    /**
     * 
     * @type {string}
     * @memberof TicketOwner
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOwner
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOwner
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOwner
     */
    organisation?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOwner
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOwner
     */
    language?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketOwner
     */
    accessibility?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum TicketOwnerSalutationEnum {
    None = 'NONE',
    Mr = 'MR',
    Ms = 'MS'
}

/**
 * 
 * @export
 * @interface TicketReportItem
 */
export interface TicketReportItem {
    /**
     * 
     * @type {string}
     * @memberof TicketReportItem
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketReportItem
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketReportItem
     */
    endTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TicketReportItem
     */
    capacity?: number;
    /**
     * 
     * @type {number}
     * @memberof TicketReportItem
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface TimeSlot
 */
export interface TimeSlot {
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TimeSlot
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    roomId: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    roomName?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    reference: string;
    /**
     * 
     * @type {number}
     * @memberof TimeSlot
     */
    capacity?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSlot
     */
    ticketCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlot
     */
    endTime: string;
}
/**
 * 
 * @export
 * @interface TimeSlotCapacityUpdate
 */
export interface TimeSlotCapacityUpdate {
    /**
     * 
     * @type {string}
     * @memberof TimeSlotCapacityUpdate
     */
    fromDate: string;
    /**
     * 
     * @type {string}
     * @memberof TimeSlotCapacityUpdate
     */
    untilDate: string;
    /**
     * 
     * @type {number}
     * @memberof TimeSlotCapacityUpdate
     */
    capacity: number;
}
/**
 * 
 * @export
 * @interface TimeSlotCreationResult
 */
export interface TimeSlotCreationResult {
    /**
     * 
     * @type {string}
     * @memberof TimeSlotCreationResult
     */
    creationId?: string;
    /**
     * 
     * @type {CreateTimeSlotDefinition}
     * @memberof TimeSlotCreationResult
     */
    definition?: CreateTimeSlotDefinition;
    /**
     * 
     * @type {number}
     * @memberof TimeSlotCreationResult
     */
    createdTimeSlots?: number;
}
/**
 * 
 * @export
 * @interface TransactionResult
 */
export interface TransactionResult {
    /**
     * 
     * @type {string}
     * @memberof TransactionResult
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResult
     */
    expiredAt?: string;
    /**
     * 
     * @type {Ticket}
     * @memberof TransactionResult
     */
    ticket?: Ticket;
}
/**
 * 
 * @export
 * @interface TransactionSummary
 */
export interface TransactionSummary {
    /**
     * 
     * @type {string}
     * @memberof TransactionSummary
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionSummary
     */
    expiredAt?: string;
    /**
     * 
     * @type {Array<Ticket>}
     * @memberof TransactionSummary
     */
    tickets?: Array<Ticket>;
}
/**
 * 
 * @export
 * @interface UpdateTimeSlot
 */
export interface UpdateTimeSlot {
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeSlot
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeSlot
     */
    endTime: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTimeSlot
     */
    capacity: number;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Email to blacklist.
         * @param {BlacklistEntry} blacklistEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmailToBlacklistByAdmin: async (blacklistEntry: BlacklistEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'blacklistEntry' is not null or undefined
            assertParamExists('addEmailToBlacklistByAdmin', 'blacklistEntry', blacklistEntry)
            const localVarPath = `/admin/blacklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blacklistEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add ticket with give data to current transaction.
         * @param {string} transactionId 
         * @param {CreateTicketDTO} createTicketDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTicket: async (transactionId: string, createTicketDTO: CreateTicketDTO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('addTicket', 'transactionId', transactionId)
            // verify required parameter 'createTicketDTO' is not null or undefined
            assertParamExists('addTicket', 'createTicketDTO', createTicketDTO)
            const localVarPath = `/transactions/{transactionId}/tickets`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a booking from current transaction and add owner information.
         * @param {string} transactionId 
         * @param {TicketOwner} ticketOwner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookTransaction: async (transactionId: string, ticketOwner: TicketOwner, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('bookTransaction', 'transactionId', transactionId)
            // verify required parameter 'ticketOwner' is not null or undefined
            assertParamExists('bookTransaction', 'ticketOwner', ticketOwner)
            const localVarPath = `/transactions/{transactionId}/booking`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ticketOwner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a holiday.
         * @param {CreateHoliday} createHoliday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolidayByAdmin: async (createHoliday: CreateHoliday, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createHoliday' is not null or undefined
            assertParamExists('createHolidayByAdmin', 'createHoliday', createHoliday)
            const localVarPath = `/admin/holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHoliday, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a room
         * @param {CreateRoom} createRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomByAdmin: async (createRoom: CreateRoom, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoom' is not null or undefined
            assertParamExists('createRoomByAdmin', 'createRoom', createRoom)
            const localVarPath = `/admin/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoom, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create timeslots for a room.
         * @param {string} id 
         * @param {CreateTimeSlotDefinition} createTimeSlotDefinition 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimeSlotsByAdmin: async (id: string, createTimeSlotDefinition: CreateTimeSlotDefinition, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTimeSlotsByAdmin', 'id', id)
            // verify required parameter 'createTimeSlotDefinition' is not null or undefined
            assertParamExists('createTimeSlotsByAdmin', 'createTimeSlotDefinition', createTimeSlotDefinition)
            const localVarPath = `/admin/rooms/{id}/timeslots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTimeSlotDefinition, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new transaction and ticket with the given ticket data.
         * @param {CreateTicketDTO} createTicketDTO 
         * @param {string} [gRecaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction: async (createTicketDTO: CreateTicketDTO, gRecaptchaResponse?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTicketDTO' is not null or undefined
            assertParamExists('createTransaction', 'createTicketDTO', createTicketDTO)
            const localVarPath = `/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gRecaptchaResponse !== undefined) {
                localVarQueryParameter['g-recaptcha-response'] = gRecaptchaResponse;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a holiday.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolidayByAdmin: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteHolidayByAdmin', 'id', id)
            const localVarPath = `/admin/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoomByAdmin: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRoomByAdmin', 'id', id)
            const localVarPath = `/admin/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a ticket.
         * @param {string} ids Comma separated list of ticket ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketsByAdmin: async (ids: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteTicketsByAdmin', 'ids', ids)
            const localVarPath = `/admin/tickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete all or given Tickets for owner.
         * @param {string} ownerId 
         * @param {string} [ids] Comma separated list of ticket ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketsByOwner: async (ownerId: string, ids?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('deleteTicketsByOwner', 'ownerId', ownerId)
            const localVarPath = `/owners/{ownerId}/tickets`
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimeSlotByAdmin: async (id: string, timeSlotId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTimeSlotByAdmin', 'id', id)
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('deleteTimeSlotByAdmin', 'timeSlotId', timeSlotId)
            const localVarPath = `/admin/rooms/{id}/timeslots/{timeSlotId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find Timeslots for all rooms by give parameters
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTimeslotsByAdmin: async (fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', limit?: number, offset?: number, sort?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/rooms/timeslots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (untilDate !== undefined) {
                localVarQueryParameter['untilDate'] = (untilDate as any instanceof Date) ?
                    (untilDate as any).toISOString().substr(0,10) :
                    untilDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find blacklist entries by given parameters.
         * @param {string} [term] 
         * @param {string} [expiresFrom] 
         * @param {string} [expiresUntil] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBlacklistEntriesByAdmin: async (term?: string, expiresFrom?: string, expiresUntil?: string, limit?: number, offset?: number, sort?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/blacklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (expiresFrom !== undefined) {
                localVarQueryParameter['expiresFrom'] = (expiresFrom as any instanceof Date) ?
                    (expiresFrom as any).toISOString().substr(0,10) :
                    expiresFrom;
            }

            if (expiresUntil !== undefined) {
                localVarQueryParameter['expiresUntil'] = (expiresUntil as any instanceof Date) ?
                    (expiresUntil as any).toISOString().substr(0,10) :
                    expiresUntil;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find holidays by give parameters
         * @param {string} [searchTerm] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHolidaysByAdmin: async (searchTerm?: string, fromDate?: string, untilDate?: string, limit?: number, offset?: number, sort?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (untilDate !== undefined) {
                localVarQueryParameter['untilDate'] = (untilDate as any instanceof Date) ?
                    (untilDate as any).toISOString().substr(0,10) :
                    untilDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find Rooms by give parameters
         * @param {string} [name] 
         * @param {string} [term] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRooms: async (name?: string, term?: string, limit?: number, offset?: number, sort?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find Rooms by give parameters
         * @param {string} [name] 
         * @param {string} [term] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRoomsByAdmin: async (name?: string, term?: string, limit?: number, offset?: number, sort?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find Tickets by give parameters
         * @param {string} [searchTerm] 
         * @param {'INCLUDE_CANCELED' | 'CANCELED_ONLY'} [status] 
         * @param {string} [roomId] 
         * @param {string} [timeSlotId] 
         * @param {string} [transactionId] 
         * @param {string} [ownerId] 
         * @param {string} [ticketId] 
         * @param {string} [bookingNumber] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {string} [fromTime] 
         * @param {string} [untilTime] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTicketsByAdmin: async (searchTerm?: string, status?: 'INCLUDE_CANCELED' | 'CANCELED_ONLY', roomId?: string, timeSlotId?: string, transactionId?: string, ownerId?: string, ticketId?: string, bookingNumber?: string, fromDate?: string, untilDate?: string, fromTime?: string, untilTime?: string, limit?: number, offset?: number, sort?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/tickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (roomId !== undefined) {
                localVarQueryParameter['roomId'] = roomId;
            }

            if (timeSlotId !== undefined) {
                localVarQueryParameter['timeSlotId'] = timeSlotId;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }

            if (ticketId !== undefined) {
                localVarQueryParameter['ticketId'] = ticketId;
            }

            if (bookingNumber !== undefined) {
                localVarQueryParameter['bookingNumber'] = bookingNumber;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (untilDate !== undefined) {
                localVarQueryParameter['untilDate'] = (untilDate as any instanceof Date) ?
                    (untilDate as any).toISOString().substr(0,10) :
                    untilDate;
            }

            if (fromTime !== undefined) {
                localVarQueryParameter['fromTime'] = fromTime;
            }

            if (untilTime !== undefined) {
                localVarQueryParameter['untilTime'] = untilTime;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find Timeslots for room by give parameters
         * @param {string} id 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTimeslotsByAdmin: async (id: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', limit?: number, offset?: number, sort?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findTimeslotsByAdmin', 'id', id)
            const localVarPath = `/admin/rooms/{id}/timeslots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (untilDate !== undefined) {
                localVarQueryParameter['untilDate'] = (untilDate as any instanceof Date) ?
                    (untilDate as any).toISOString().substr(0,10) :
                    untilDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all parameters to create bookings for the given room.
         * @param {string} id 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTimeSlotsByRoom: async (id: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAvailableTimeSlotsByRoom', 'id', id)
            const localVarPath = `/rooms/{id}/booking`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (untilDate !== undefined) {
                localVarQueryParameter['untilDate'] = (untilDate as any instanceof Date) ?
                    (untilDate as any).toISOString().substr(0,10) :
                    untilDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all parameters to create bookings for the given room. The hard limit is 100.
         * @param {string} transactionId 
         * @param {string} roomId 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTimeSlotsByTransaction: async (transactionId: string, roomId: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getAvailableTimeSlotsByTransaction', 'transactionId', transactionId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getAvailableTimeSlotsByTransaction', 'roomId', roomId)
            const localVarPath = `/transactions/{transactionId}/rooms/{roomId}/available-timeslots`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (untilDate !== undefined) {
                localVarQueryParameter['untilDate'] = (untilDate as any instanceof Date) ?
                    (untilDate as any).toISOString().substr(0,10) :
                    untilDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a blacklist entry by given email.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlacklistEntryByAdmin: async (email: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getBlacklistEntryByAdmin', 'email', email)
            const localVarPath = `/admin/blacklist/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a holiday by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidayByAdmin: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHolidayByAdmin', 'id', id)
            const localVarPath = `/admin/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a room.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoom: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRoom', 'id', id)
            const localVarPath = `/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a room by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomByAdmin: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRoomByAdmin', 'id', id)
            const localVarPath = `/admin/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an Image of a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomImage: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRoomImage', 'id', id)
            const localVarPath = `/rooms/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an Image of a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomImageByAdmin: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRoomImageByAdmin', 'id', id)
            const localVarPath = `/admin/rooms/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a ticket by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketByAdmin: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTicketByAdmin', 'id', id)
            const localVarPath = `/admin/tickets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Ticket for owner.
         * @param {string} ownerId 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketByOwner: async (ownerId: string, ticketId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('getTicketByOwner', 'ownerId', ownerId)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getTicketByOwner', 'ticketId', ticketId)
            const localVarPath = `/owners/{ownerId}/tickets/{ticketId}`
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)))
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get report for tickets.
         * @param {string} [roomId] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'NEW' | 'BOOKED' | 'CANCELLED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketReportByAdmin: async (roomId?: string, fromDate?: string, untilDate?: string, status?: 'NEW' | 'BOOKED' | 'CANCELLED', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/tickets/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roomId !== undefined) {
                localVarQueryParameter['roomId'] = roomId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substr(0,10) :
                    fromDate;
            }

            if (untilDate !== undefined) {
                localVarQueryParameter['untilDate'] = (untilDate as any instanceof Date) ?
                    (untilDate as any).toISOString().substr(0,10) :
                    untilDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Tickets for owner.
         * @param {string} ownerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsByOwner: async (ownerId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('getTicketsByOwner', 'ownerId', ownerId)
            const localVarPath = `/owners/{ownerId}/tickets`
                .replace(`{${"ownerId"}}`, encodeURIComponent(String(ownerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single timeslot
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSlotByAdmin: async (id: string, timeSlotId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTimeSlotByAdmin', 'id', id)
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('getTimeSlotByAdmin', 'timeSlotId', timeSlotId)
            const localVarPath = `/admin/rooms/{id}/timeslots/{timeSlotId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get summary of current transaction.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionSummary: async (transactionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getTransactionSummary', 'transactionId', transactionId)
            const localVarPath = `/transactions/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {number} order 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderRoom: async (id: string, order: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderRoom', 'id', id)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('orderRoom', 'order', order)
            const localVarPath = `/admin/rooms/{id}/order/{order}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"order"}}`, encodeURIComponent(String(order)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove email from blacklist.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmailFromBlacklist: async (email: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('removeEmailFromBlacklist', 'email', email)
            const localVarPath = `/admin/blacklist/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an Image from a room.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoomImageByAdmin: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeRoomImageByAdmin', 'id', id)
            const localVarPath = `/admin/rooms/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove ticket from current transaction.
         * @param {string} transactionId 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTicketByTransaction: async (transactionId: string, ticketId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('removeTicketByTransaction', 'transactionId', transactionId)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('removeTicketByTransaction', 'ticketId', ticketId)
            const localVarPath = `/transactions/{transactionId}/tickets/{ticketId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)))
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove current transaction.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTransaction: async (transactionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('removeTransaction', 'transactionId', transactionId)
            const localVarPath = `/transactions/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Touches the current transaction and reset expiring time.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        touchTransaction: async (transactionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('touchTransaction', 'transactionId', transactionId)
            const localVarPath = `/transactions/{transactionId}/touch`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a holiday
         * @param {string} id 
         * @param {Holiday} holiday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHoliday: async (id: string, holiday: Holiday, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHoliday', 'id', id)
            // verify required parameter 'holiday' is not null or undefined
            assertParamExists('updateHoliday', 'holiday', holiday)
            const localVarPath = `/admin/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(holiday, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a room
         * @param {string} id 
         * @param {Room} room 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoomByAdmin: async (id: string, room: Room, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRoomByAdmin', 'id', id)
            // verify required parameter 'room' is not null or undefined
            assertParamExists('updateRoomByAdmin', 'room', room)
            const localVarPath = `/admin/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(room, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a ticket
         * @param {string} id 
         * @param {TicketOwner} ticketOwner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketOwnerByAdmin: async (id: string, ticketOwner: TicketOwner, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTicketOwnerByAdmin', 'id', id)
            // verify required parameter 'ticketOwner' is not null or undefined
            assertParamExists('updateTicketOwnerByAdmin', 'ticketOwner', ticketOwner)
            const localVarPath = `/admin/tickets/{id}/owner`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ticketOwner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Timeslot.
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {UpdateTimeSlot} updateTimeSlot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeSlotByAdmin: async (id: string, timeSlotId: string, updateTimeSlot: UpdateTimeSlot, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTimeSlotByAdmin', 'id', id)
            // verify required parameter 'timeSlotId' is not null or undefined
            assertParamExists('updateTimeSlotByAdmin', 'timeSlotId', timeSlotId)
            // verify required parameter 'updateTimeSlot' is not null or undefined
            assertParamExists('updateTimeSlotByAdmin', 'updateTimeSlot', updateTimeSlot)
            const localVarPath = `/admin/rooms/{id}/timeslots/{timeSlotId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"timeSlotId"}}`, encodeURIComponent(String(timeSlotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTimeSlot, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update capacity of multiple timeslot in a date range.
         * @param {string} id 
         * @param {TimeSlotCapacityUpdate} timeSlotCapacityUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeSlotsCapacityByAdmin: async (id: string, timeSlotCapacityUpdate: TimeSlotCapacityUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTimeSlotsCapacityByAdmin', 'id', id)
            // verify required parameter 'timeSlotCapacityUpdate' is not null or undefined
            assertParamExists('updateTimeSlotsCapacityByAdmin', 'timeSlotCapacityUpdate', timeSlotCapacityUpdate)
            const localVarPath = `/admin/rooms/{id}/timeslots/capacity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(timeSlotCapacityUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an ICal File for import.
         * @param {any} file Calendar file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadHolidayICalByAdmin: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadHolidayICalByAdmin', 'file', file)
            const localVarPath = `/admin/holidays/ical`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an Image to a room.
         * @param {string} id 
         * @param {any} image Image file
         * @param {string} [alt] Image alt text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRoomImageByAdmin: async (id: string, image: any, alt?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadRoomImageByAdmin', 'id', id)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('uploadRoomImageByAdmin', 'image', image)
            const localVarPath = `/admin/rooms/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (alt !== undefined) { 
                localVarFormParams.append('alt', alt as any);
            }
    
            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Email to blacklist.
         * @param {BlacklistEntry} blacklistEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmailToBlacklistByAdmin(blacklistEntry: BlacklistEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlacklistEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEmailToBlacklistByAdmin(blacklistEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add ticket with give data to current transaction.
         * @param {string} transactionId 
         * @param {CreateTicketDTO} createTicketDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTicket(transactionId: string, createTicketDTO: CreateTicketDTO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTicket(transactionId, createTicketDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a booking from current transaction and add owner information.
         * @param {string} transactionId 
         * @param {TicketOwner} ticketOwner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookTransaction(transactionId: string, ticketOwner: TicketOwner, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookTransaction(transactionId, ticketOwner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a holiday.
         * @param {CreateHoliday} createHoliday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHolidayByAdmin(createHoliday: CreateHoliday, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHolidayByAdmin(createHoliday, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a room
         * @param {CreateRoom} createRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoomByAdmin(createRoom: CreateRoom, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoomByAdmin(createRoom, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create timeslots for a room.
         * @param {string} id 
         * @param {CreateTimeSlotDefinition} createTimeSlotDefinition 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTimeSlotsByAdmin(id: string, createTimeSlotDefinition: CreateTimeSlotDefinition, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlotCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTimeSlotsByAdmin(id, createTimeSlotDefinition, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new transaction and ticket with the given ticket data.
         * @param {CreateTicketDTO} createTicketDTO 
         * @param {string} [gRecaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransaction(createTicketDTO: CreateTicketDTO, gRecaptchaResponse?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransaction(createTicketDTO, gRecaptchaResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a holiday.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHolidayByAdmin(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHolidayByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoomByAdmin(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoomByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a ticket.
         * @param {string} ids Comma separated list of ticket ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTicketsByAdmin(ids: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicketsByAdmin(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete all or given Tickets for owner.
         * @param {string} ownerId 
         * @param {string} [ids] Comma separated list of ticket ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTicketsByOwner(ownerId: string, ids?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicketsByOwner(ownerId, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTimeSlotByAdmin(id: string, timeSlotId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTimeSlotByAdmin(id, timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find Timeslots for all rooms by give parameters
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTimeslotsByAdmin(fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', limit?: number, offset?: number, sort?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultTimeSlot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllTimeslotsByAdmin(fromDate, untilDate, status, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find blacklist entries by given parameters.
         * @param {string} [term] 
         * @param {string} [expiresFrom] 
         * @param {string} [expiresUntil] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBlacklistEntriesByAdmin(term?: string, expiresFrom?: string, expiresUntil?: string, limit?: number, offset?: number, sort?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultBlacklistEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBlacklistEntriesByAdmin(term, expiresFrom, expiresUntil, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find holidays by give parameters
         * @param {string} [searchTerm] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findHolidaysByAdmin(searchTerm?: string, fromDate?: string, untilDate?: string, limit?: number, offset?: number, sort?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultHoliday>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findHolidaysByAdmin(searchTerm, fromDate, untilDate, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find Rooms by give parameters
         * @param {string} [name] 
         * @param {string} [term] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRooms(name?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultRoomDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRooms(name, term, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find Rooms by give parameters
         * @param {string} [name] 
         * @param {string} [term] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRoomsByAdmin(name?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultRoomDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRoomsByAdmin(name, term, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find Tickets by give parameters
         * @param {string} [searchTerm] 
         * @param {'INCLUDE_CANCELED' | 'CANCELED_ONLY'} [status] 
         * @param {string} [roomId] 
         * @param {string} [timeSlotId] 
         * @param {string} [transactionId] 
         * @param {string} [ownerId] 
         * @param {string} [ticketId] 
         * @param {string} [bookingNumber] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {string} [fromTime] 
         * @param {string} [untilTime] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTicketsByAdmin(searchTerm?: string, status?: 'INCLUDE_CANCELED' | 'CANCELED_ONLY', roomId?: string, timeSlotId?: string, transactionId?: string, ownerId?: string, ticketId?: string, bookingNumber?: string, fromDate?: string, untilDate?: string, fromTime?: string, untilTime?: string, limit?: number, offset?: number, sort?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultTicket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTicketsByAdmin(searchTerm, status, roomId, timeSlotId, transactionId, ownerId, ticketId, bookingNumber, fromDate, untilDate, fromTime, untilTime, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Find Timeslots for room by give parameters
         * @param {string} id 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTimeslotsByAdmin(id: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', limit?: number, offset?: number, sort?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultTimeSlot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTimeslotsByAdmin(id, fromDate, untilDate, status, limit, offset, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all parameters to create bookings for the given room.
         * @param {string} id 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTimeSlotsByRoom(id: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookableTimeSlot>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTimeSlotsByRoom(id, fromDate, untilDate, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all parameters to create bookings for the given room. The hard limit is 100.
         * @param {string} transactionId 
         * @param {string} roomId 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTimeSlotsByTransaction(transactionId: string, roomId: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookableTimeSlot>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTimeSlotsByTransaction(transactionId, roomId, fromDate, untilDate, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a blacklist entry by given email.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlacklistEntryByAdmin(email: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlacklistEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlacklistEntryByAdmin(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a holiday by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHolidayByAdmin(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHolidayByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a room.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoom(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoom(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a room by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomByAdmin(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download an Image of a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomImage(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomImage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download an Image of a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoomImageByAdmin(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoomImageByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a ticket by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketByAdmin(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a Ticket for owner.
         * @param {string} ownerId 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketByOwner(ownerId: string, ticketId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketByOwner(ownerId, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get report for tickets.
         * @param {string} [roomId] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'NEW' | 'BOOKED' | 'CANCELLED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketReportByAdmin(roomId?: string, fromDate?: string, untilDate?: string, status?: 'NEW' | 'BOOKED' | 'CANCELLED', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketReportItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketReportByAdmin(roomId, fromDate, untilDate, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all Tickets for owner.
         * @param {string} ownerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTicketsByOwner(ownerId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ticket>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTicketsByOwner(ownerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single timeslot
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeSlotByAdmin(id: string, timeSlotId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeSlotByAdmin(id, timeSlotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get summary of current transaction.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionSummary(transactionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionSummary(transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {number} order 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderRoom(id: string, order: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderRoom(id, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove email from blacklist.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEmailFromBlacklist(email: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEmailFromBlacklist(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove an Image from a room.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRoomImageByAdmin(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRoomImageByAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove ticket from current transaction.
         * @param {string} transactionId 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTicketByTransaction(transactionId: string, ticketId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTicketByTransaction(transactionId, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove current transaction.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTransaction(transactionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTransaction(transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Touches the current transaction and reset expiring time.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async touchTransaction(transactionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.touchTransaction(transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a holiday
         * @param {string} id 
         * @param {Holiday} holiday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHoliday(id: string, holiday: Holiday, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Holiday>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHoliday(id, holiday, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a room
         * @param {string} id 
         * @param {Room} room 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoomByAdmin(id: string, room: Room, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoomByAdmin(id, room, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a ticket
         * @param {string} id 
         * @param {TicketOwner} ticketOwner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTicketOwnerByAdmin(id: string, ticketOwner: TicketOwner, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicketOwnerByAdmin(id, ticketOwner, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Timeslot.
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {UpdateTimeSlot} updateTimeSlot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimeSlotByAdmin(id: string, timeSlotId: string, updateTimeSlot: UpdateTimeSlot, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeSlot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimeSlotByAdmin(id, timeSlotId, updateTimeSlot, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update capacity of multiple timeslot in a date range.
         * @param {string} id 
         * @param {TimeSlotCapacityUpdate} timeSlotCapacityUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimeSlotsCapacityByAdmin(id: string, timeSlotCapacityUpdate: TimeSlotCapacityUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimeSlotsCapacityByAdmin(id, timeSlotCapacityUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload an ICal File for import.
         * @param {any} file Calendar file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadHolidayICalByAdmin(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICalImportResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadHolidayICalByAdmin(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload an Image to a room.
         * @param {string} id 
         * @param {any} image Image file
         * @param {string} [alt] Image alt text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadRoomImageByAdmin(id: string, image: any, alt?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadRoomImageByAdmin(id, image, alt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Email to blacklist.
         * @param {BlacklistEntry} blacklistEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmailToBlacklistByAdmin(blacklistEntry: BlacklistEntry, options?: any): AxiosPromise<BlacklistEntry> {
            return localVarFp.addEmailToBlacklistByAdmin(blacklistEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add ticket with give data to current transaction.
         * @param {string} transactionId 
         * @param {CreateTicketDTO} createTicketDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTicket(transactionId: string, createTicketDTO: CreateTicketDTO, options?: any): AxiosPromise<TransactionResult> {
            return localVarFp.addTicket(transactionId, createTicketDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a booking from current transaction and add owner information.
         * @param {string} transactionId 
         * @param {TicketOwner} ticketOwner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookTransaction(transactionId: string, ticketOwner: TicketOwner, options?: any): AxiosPromise<BookingResult> {
            return localVarFp.bookTransaction(transactionId, ticketOwner, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a holiday.
         * @param {CreateHoliday} createHoliday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHolidayByAdmin(createHoliday: CreateHoliday, options?: any): AxiosPromise<Holiday> {
            return localVarFp.createHolidayByAdmin(createHoliday, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a room
         * @param {CreateRoom} createRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomByAdmin(createRoom: CreateRoom, options?: any): AxiosPromise<void> {
            return localVarFp.createRoomByAdmin(createRoom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create timeslots for a room.
         * @param {string} id 
         * @param {CreateTimeSlotDefinition} createTimeSlotDefinition 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTimeSlotsByAdmin(id: string, createTimeSlotDefinition: CreateTimeSlotDefinition, options?: any): AxiosPromise<TimeSlotCreationResult> {
            return localVarFp.createTimeSlotsByAdmin(id, createTimeSlotDefinition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new transaction and ticket with the given ticket data.
         * @param {CreateTicketDTO} createTicketDTO 
         * @param {string} [gRecaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransaction(createTicketDTO: CreateTicketDTO, gRecaptchaResponse?: string, options?: any): AxiosPromise<TransactionResult> {
            return localVarFp.createTransaction(createTicketDTO, gRecaptchaResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a holiday.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHolidayByAdmin(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteHolidayByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoomByAdmin(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRoomByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a ticket.
         * @param {string} ids Comma separated list of ticket ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketsByAdmin(ids: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTicketsByAdmin(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete all or given Tickets for owner.
         * @param {string} ownerId 
         * @param {string} [ids] Comma separated list of ticket ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTicketsByOwner(ownerId: string, ids?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTicketsByOwner(ownerId, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTimeSlotByAdmin(id: string, timeSlotId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTimeSlotByAdmin(id, timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find Timeslots for all rooms by give parameters
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTimeslotsByAdmin(fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultTimeSlot> {
            return localVarFp.findAllTimeslotsByAdmin(fromDate, untilDate, status, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find blacklist entries by given parameters.
         * @param {string} [term] 
         * @param {string} [expiresFrom] 
         * @param {string} [expiresUntil] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBlacklistEntriesByAdmin(term?: string, expiresFrom?: string, expiresUntil?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultBlacklistEntry> {
            return localVarFp.findBlacklistEntriesByAdmin(term, expiresFrom, expiresUntil, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find holidays by give parameters
         * @param {string} [searchTerm] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findHolidaysByAdmin(searchTerm?: string, fromDate?: string, untilDate?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultHoliday> {
            return localVarFp.findHolidaysByAdmin(searchTerm, fromDate, untilDate, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find Rooms by give parameters
         * @param {string} [name] 
         * @param {string} [term] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRooms(name?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultRoomDTO> {
            return localVarFp.findRooms(name, term, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find Rooms by give parameters
         * @param {string} [name] 
         * @param {string} [term] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRoomsByAdmin(name?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultRoomDTO> {
            return localVarFp.findRoomsByAdmin(name, term, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find Tickets by give parameters
         * @param {string} [searchTerm] 
         * @param {'INCLUDE_CANCELED' | 'CANCELED_ONLY'} [status] 
         * @param {string} [roomId] 
         * @param {string} [timeSlotId] 
         * @param {string} [transactionId] 
         * @param {string} [ownerId] 
         * @param {string} [ticketId] 
         * @param {string} [bookingNumber] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {string} [fromTime] 
         * @param {string} [untilTime] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTicketsByAdmin(searchTerm?: string, status?: 'INCLUDE_CANCELED' | 'CANCELED_ONLY', roomId?: string, timeSlotId?: string, transactionId?: string, ownerId?: string, ticketId?: string, bookingNumber?: string, fromDate?: string, untilDate?: string, fromTime?: string, untilTime?: string, limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultTicket> {
            return localVarFp.findTicketsByAdmin(searchTerm, status, roomId, timeSlotId, transactionId, ownerId, ticketId, bookingNumber, fromDate, untilDate, fromTime, untilTime, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find Timeslots for room by give parameters
         * @param {string} id 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
         * @param {number} [offset] Position of record where to start
         * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTimeslotsByAdmin(id: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', limit?: number, offset?: number, sort?: string, options?: any): AxiosPromise<ResultTimeSlot> {
            return localVarFp.findTimeslotsByAdmin(id, fromDate, untilDate, status, limit, offset, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all parameters to create bookings for the given room.
         * @param {string} id 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTimeSlotsByRoom(id: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', options?: any): AxiosPromise<Array<BookableTimeSlot>> {
            return localVarFp.getAvailableTimeSlotsByRoom(id, fromDate, untilDate, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all parameters to create bookings for the given room. The hard limit is 100.
         * @param {string} transactionId 
         * @param {string} roomId 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTimeSlotsByTransaction(transactionId: string, roomId: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', options?: any): AxiosPromise<Array<BookableTimeSlot>> {
            return localVarFp.getAvailableTimeSlotsByTransaction(transactionId, roomId, fromDate, untilDate, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a blacklist entry by given email.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlacklistEntryByAdmin(email: string, options?: any): AxiosPromise<BlacklistEntry> {
            return localVarFp.getBlacklistEntryByAdmin(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a holiday by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidayByAdmin(id: string, options?: any): AxiosPromise<Holiday> {
            return localVarFp.getHolidayByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a room.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoom(id: string, options?: any): AxiosPromise<Room> {
            return localVarFp.getRoom(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a room by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomByAdmin(id: string, options?: any): AxiosPromise<Room> {
            return localVarFp.getRoomByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an Image of a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomImage(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getRoomImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an Image of a room
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoomImageByAdmin(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getRoomImageByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a ticket by given ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketByAdmin(id: string, options?: any): AxiosPromise<Ticket> {
            return localVarFp.getTicketByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Ticket for owner.
         * @param {string} ownerId 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketByOwner(ownerId: string, ticketId: string, options?: any): AxiosPromise<Ticket> {
            return localVarFp.getTicketByOwner(ownerId, ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get report for tickets.
         * @param {string} [roomId] 
         * @param {string} [fromDate] 
         * @param {string} [untilDate] 
         * @param {'NEW' | 'BOOKED' | 'CANCELLED'} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketReportByAdmin(roomId?: string, fromDate?: string, untilDate?: string, status?: 'NEW' | 'BOOKED' | 'CANCELLED', options?: any): AxiosPromise<Array<TicketReportItem>> {
            return localVarFp.getTicketReportByAdmin(roomId, fromDate, untilDate, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Tickets for owner.
         * @param {string} ownerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTicketsByOwner(ownerId: string, options?: any): AxiosPromise<Array<Ticket>> {
            return localVarFp.getTicketsByOwner(ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single timeslot
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeSlotByAdmin(id: string, timeSlotId: string, options?: any): AxiosPromise<TimeSlot> {
            return localVarFp.getTimeSlotByAdmin(id, timeSlotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get summary of current transaction.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionSummary(transactionId: string, options?: any): AxiosPromise<TransactionSummary> {
            return localVarFp.getTransactionSummary(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a room
         * @param {string} id 
         * @param {number} order 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderRoom(id: string, order: number, options?: any): AxiosPromise<void> {
            return localVarFp.orderRoom(id, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove email from blacklist.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmailFromBlacklist(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeEmailFromBlacklist(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an Image from a room.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoomImageByAdmin(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeRoomImageByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove ticket from current transaction.
         * @param {string} transactionId 
         * @param {string} ticketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTicketByTransaction(transactionId: string, ticketId: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeTicketByTransaction(transactionId, ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove current transaction.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTransaction(transactionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeTransaction(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Touches the current transaction and reset expiring time.
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        touchTransaction(transactionId: string, options?: any): AxiosPromise<TransactionResult> {
            return localVarFp.touchTransaction(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a holiday
         * @param {string} id 
         * @param {Holiday} holiday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHoliday(id: string, holiday: Holiday, options?: any): AxiosPromise<Holiday> {
            return localVarFp.updateHoliday(id, holiday, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a room
         * @param {string} id 
         * @param {Room} room 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoomByAdmin(id: string, room: Room, options?: any): AxiosPromise<Room> {
            return localVarFp.updateRoomByAdmin(id, room, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a ticket
         * @param {string} id 
         * @param {TicketOwner} ticketOwner 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTicketOwnerByAdmin(id: string, ticketOwner: TicketOwner, options?: any): AxiosPromise<Ticket> {
            return localVarFp.updateTicketOwnerByAdmin(id, ticketOwner, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Timeslot.
         * @param {string} id 
         * @param {string} timeSlotId 
         * @param {UpdateTimeSlot} updateTimeSlot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeSlotByAdmin(id: string, timeSlotId: string, updateTimeSlot: UpdateTimeSlot, options?: any): AxiosPromise<TimeSlot> {
            return localVarFp.updateTimeSlotByAdmin(id, timeSlotId, updateTimeSlot, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update capacity of multiple timeslot in a date range.
         * @param {string} id 
         * @param {TimeSlotCapacityUpdate} timeSlotCapacityUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeSlotsCapacityByAdmin(id: string, timeSlotCapacityUpdate: TimeSlotCapacityUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.updateTimeSlotsCapacityByAdmin(id, timeSlotCapacityUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an ICal File for import.
         * @param {any} file Calendar file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadHolidayICalByAdmin(file: any, options?: any): AxiosPromise<ICalImportResult> {
            return localVarFp.uploadHolidayICalByAdmin(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an Image to a room.
         * @param {string} id 
         * @param {any} image Image file
         * @param {string} [alt] Image alt text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRoomImageByAdmin(id: string, image: any, alt?: string, options?: any): AxiosPromise<void> {
            return localVarFp.uploadRoomImageByAdmin(id, image, alt, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Add Email to blacklist.
     * @param {BlacklistEntry} blacklistEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addEmailToBlacklistByAdmin(blacklistEntry: BlacklistEntry, options?: any) {
        return DefaultApiFp(this.configuration).addEmailToBlacklistByAdmin(blacklistEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add ticket with give data to current transaction.
     * @param {string} transactionId 
     * @param {CreateTicketDTO} createTicketDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addTicket(transactionId: string, createTicketDTO: CreateTicketDTO, options?: any) {
        return DefaultApiFp(this.configuration).addTicket(transactionId, createTicketDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a booking from current transaction and add owner information.
     * @param {string} transactionId 
     * @param {TicketOwner} ticketOwner 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bookTransaction(transactionId: string, ticketOwner: TicketOwner, options?: any) {
        return DefaultApiFp(this.configuration).bookTransaction(transactionId, ticketOwner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a holiday.
     * @param {CreateHoliday} createHoliday 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createHolidayByAdmin(createHoliday: CreateHoliday, options?: any) {
        return DefaultApiFp(this.configuration).createHolidayByAdmin(createHoliday, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a room
     * @param {CreateRoom} createRoom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createRoomByAdmin(createRoom: CreateRoom, options?: any) {
        return DefaultApiFp(this.configuration).createRoomByAdmin(createRoom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create timeslots for a room.
     * @param {string} id 
     * @param {CreateTimeSlotDefinition} createTimeSlotDefinition 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTimeSlotsByAdmin(id: string, createTimeSlotDefinition: CreateTimeSlotDefinition, options?: any) {
        return DefaultApiFp(this.configuration).createTimeSlotsByAdmin(id, createTimeSlotDefinition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new transaction and ticket with the given ticket data.
     * @param {CreateTicketDTO} createTicketDTO 
     * @param {string} [gRecaptchaResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createTransaction(createTicketDTO: CreateTicketDTO, gRecaptchaResponse?: string, options?: any) {
        return DefaultApiFp(this.configuration).createTransaction(createTicketDTO, gRecaptchaResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a holiday.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteHolidayByAdmin(id: string, options?: any) {
        return DefaultApiFp(this.configuration).deleteHolidayByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a room
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteRoomByAdmin(id: string, options?: any) {
        return DefaultApiFp(this.configuration).deleteRoomByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a ticket.
     * @param {string} ids Comma separated list of ticket ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTicketsByAdmin(ids: string, options?: any) {
        return DefaultApiFp(this.configuration).deleteTicketsByAdmin(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete all or given Tickets for owner.
     * @param {string} ownerId 
     * @param {string} [ids] Comma separated list of ticket ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTicketsByOwner(ownerId: string, ids?: string, options?: any) {
        return DefaultApiFp(this.configuration).deleteTicketsByOwner(ownerId, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a room
     * @param {string} id 
     * @param {string} timeSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteTimeSlotByAdmin(id: string, timeSlotId: string, options?: any) {
        return DefaultApiFp(this.configuration).deleteTimeSlotByAdmin(id, timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find Timeslots for all rooms by give parameters
     * @param {string} [fromDate] 
     * @param {string} [untilDate] 
     * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findAllTimeslotsByAdmin(fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', limit?: number, offset?: number, sort?: string, options?: any) {
        return DefaultApiFp(this.configuration).findAllTimeslotsByAdmin(fromDate, untilDate, status, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find blacklist entries by given parameters.
     * @param {string} [term] 
     * @param {string} [expiresFrom] 
     * @param {string} [expiresUntil] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findBlacklistEntriesByAdmin(term?: string, expiresFrom?: string, expiresUntil?: string, limit?: number, offset?: number, sort?: string, options?: any) {
        return DefaultApiFp(this.configuration).findBlacklistEntriesByAdmin(term, expiresFrom, expiresUntil, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find holidays by give parameters
     * @param {string} [searchTerm] 
     * @param {string} [fromDate] 
     * @param {string} [untilDate] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findHolidaysByAdmin(searchTerm?: string, fromDate?: string, untilDate?: string, limit?: number, offset?: number, sort?: string, options?: any) {
        return DefaultApiFp(this.configuration).findHolidaysByAdmin(searchTerm, fromDate, untilDate, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find Rooms by give parameters
     * @param {string} [name] 
     * @param {string} [term] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findRooms(name?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: any) {
        return DefaultApiFp(this.configuration).findRooms(name, term, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find Rooms by give parameters
     * @param {string} [name] 
     * @param {string} [term] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findRoomsByAdmin(name?: string, term?: string, limit?: number, offset?: number, sort?: string, options?: any) {
        return DefaultApiFp(this.configuration).findRoomsByAdmin(name, term, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find Tickets by give parameters
     * @param {string} [searchTerm] 
     * @param {'INCLUDE_CANCELED' | 'CANCELED_ONLY'} [status] 
     * @param {string} [roomId] 
     * @param {string} [timeSlotId] 
     * @param {string} [transactionId] 
     * @param {string} [ownerId] 
     * @param {string} [ticketId] 
     * @param {string} [bookingNumber] 
     * @param {string} [fromDate] 
     * @param {string} [untilDate] 
     * @param {string} [fromTime] 
     * @param {string} [untilTime] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findTicketsByAdmin(searchTerm?: string, status?: 'INCLUDE_CANCELED' | 'CANCELED_ONLY', roomId?: string, timeSlotId?: string, transactionId?: string, ownerId?: string, ticketId?: string, bookingNumber?: string, fromDate?: string, untilDate?: string, fromTime?: string, untilTime?: string, limit?: number, offset?: number, sort?: string, options?: any) {
        return DefaultApiFp(this.configuration).findTicketsByAdmin(searchTerm, status, roomId, timeSlotId, transactionId, ownerId, ticketId, bookingNumber, fromDate, untilDate, fromTime, untilTime, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find Timeslots for room by give parameters
     * @param {string} id 
     * @param {string} [fromDate] 
     * @param {string} [untilDate] 
     * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
     * @param {number} [limit] Maximum number of records in result. By default it\&#39;s 100. The maximum is 1000.
     * @param {number} [offset] Position of record where to start
     * @param {string} [sort] Comma separated list of sort params. The direction could append to the sort property by a colon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findTimeslotsByAdmin(id: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', limit?: number, offset?: number, sort?: string, options?: any) {
        return DefaultApiFp(this.configuration).findTimeslotsByAdmin(id, fromDate, untilDate, status, limit, offset, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all parameters to create bookings for the given room.
     * @param {string} id 
     * @param {string} [fromDate] 
     * @param {string} [untilDate] 
     * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableTimeSlotsByRoom(id: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', options?: any) {
        return DefaultApiFp(this.configuration).getAvailableTimeSlotsByRoom(id, fromDate, untilDate, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all parameters to create bookings for the given room. The hard limit is 100.
     * @param {string} transactionId 
     * @param {string} roomId 
     * @param {string} [fromDate] 
     * @param {string} [untilDate] 
     * @param {'ACTIVE' | 'OVERBOOKED'} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableTimeSlotsByTransaction(transactionId: string, roomId: string, fromDate?: string, untilDate?: string, status?: 'ACTIVE' | 'OVERBOOKED', options?: any) {
        return DefaultApiFp(this.configuration).getAvailableTimeSlotsByTransaction(transactionId, roomId, fromDate, untilDate, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a blacklist entry by given email.
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBlacklistEntryByAdmin(email: string, options?: any) {
        return DefaultApiFp(this.configuration).getBlacklistEntryByAdmin(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a holiday by given ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getHolidayByAdmin(id: string, options?: any) {
        return DefaultApiFp(this.configuration).getHolidayByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a room.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRoom(id: string, options?: any) {
        return DefaultApiFp(this.configuration).getRoom(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a room by given ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRoomByAdmin(id: string, options?: any) {
        return DefaultApiFp(this.configuration).getRoomByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an Image of a room
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRoomImage(id: string, options?: any) {
        return DefaultApiFp(this.configuration).getRoomImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an Image of a room
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRoomImageByAdmin(id: string, options?: any) {
        return DefaultApiFp(this.configuration).getRoomImageByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a ticket by given ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTicketByAdmin(id: string, options?: any) {
        return DefaultApiFp(this.configuration).getTicketByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Ticket for owner.
     * @param {string} ownerId 
     * @param {string} ticketId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTicketByOwner(ownerId: string, ticketId: string, options?: any) {
        return DefaultApiFp(this.configuration).getTicketByOwner(ownerId, ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get report for tickets.
     * @param {string} [roomId] 
     * @param {string} [fromDate] 
     * @param {string} [untilDate] 
     * @param {'NEW' | 'BOOKED' | 'CANCELLED'} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTicketReportByAdmin(roomId?: string, fromDate?: string, untilDate?: string, status?: 'NEW' | 'BOOKED' | 'CANCELLED', options?: any) {
        return DefaultApiFp(this.configuration).getTicketReportByAdmin(roomId, fromDate, untilDate, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Tickets for owner.
     * @param {string} ownerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTicketsByOwner(ownerId: string, options?: any) {
        return DefaultApiFp(this.configuration).getTicketsByOwner(ownerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single timeslot
     * @param {string} id 
     * @param {string} timeSlotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTimeSlotByAdmin(id: string, timeSlotId: string, options?: any) {
        return DefaultApiFp(this.configuration).getTimeSlotByAdmin(id, timeSlotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get summary of current transaction.
     * @param {string} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTransactionSummary(transactionId: string, options?: any) {
        return DefaultApiFp(this.configuration).getTransactionSummary(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a room
     * @param {string} id 
     * @param {number} order 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public orderRoom(id: string, order: number, options?: any) {
        return DefaultApiFp(this.configuration).orderRoom(id, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove email from blacklist.
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeEmailFromBlacklist(email: string, options?: any) {
        return DefaultApiFp(this.configuration).removeEmailFromBlacklist(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an Image from a room.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeRoomImageByAdmin(id: string, options?: any) {
        return DefaultApiFp(this.configuration).removeRoomImageByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove ticket from current transaction.
     * @param {string} transactionId 
     * @param {string} ticketId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeTicketByTransaction(transactionId: string, ticketId: string, options?: any) {
        return DefaultApiFp(this.configuration).removeTicketByTransaction(transactionId, ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove current transaction.
     * @param {string} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public removeTransaction(transactionId: string, options?: any) {
        return DefaultApiFp(this.configuration).removeTransaction(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Touches the current transaction and reset expiring time.
     * @param {string} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public touchTransaction(transactionId: string, options?: any) {
        return DefaultApiFp(this.configuration).touchTransaction(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a holiday
     * @param {string} id 
     * @param {Holiday} holiday 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateHoliday(id: string, holiday: Holiday, options?: any) {
        return DefaultApiFp(this.configuration).updateHoliday(id, holiday, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a room
     * @param {string} id 
     * @param {Room} room 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRoomByAdmin(id: string, room: Room, options?: any) {
        return DefaultApiFp(this.configuration).updateRoomByAdmin(id, room, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a ticket
     * @param {string} id 
     * @param {TicketOwner} ticketOwner 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTicketOwnerByAdmin(id: string, ticketOwner: TicketOwner, options?: any) {
        return DefaultApiFp(this.configuration).updateTicketOwnerByAdmin(id, ticketOwner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Timeslot.
     * @param {string} id 
     * @param {string} timeSlotId 
     * @param {UpdateTimeSlot} updateTimeSlot 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTimeSlotByAdmin(id: string, timeSlotId: string, updateTimeSlot: UpdateTimeSlot, options?: any) {
        return DefaultApiFp(this.configuration).updateTimeSlotByAdmin(id, timeSlotId, updateTimeSlot, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update capacity of multiple timeslot in a date range.
     * @param {string} id 
     * @param {TimeSlotCapacityUpdate} timeSlotCapacityUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateTimeSlotsCapacityByAdmin(id: string, timeSlotCapacityUpdate: TimeSlotCapacityUpdate, options?: any) {
        return DefaultApiFp(this.configuration).updateTimeSlotsCapacityByAdmin(id, timeSlotCapacityUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an ICal File for import.
     * @param {any} file Calendar file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadHolidayICalByAdmin(file: any, options?: any) {
        return DefaultApiFp(this.configuration).uploadHolidayICalByAdmin(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an Image to a room.
     * @param {string} id 
     * @param {any} image Image file
     * @param {string} [alt] Image alt text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public uploadRoomImageByAdmin(id: string, image: any, alt?: string, options?: any) {
        return DefaultApiFp(this.configuration).uploadRoomImageByAdmin(id, image, alt, options).then((request) => request(this.axios, this.basePath));
    }
}


